import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { WARNING_CHIP } from '../../IndividualPlan/tokens';
import { ROSTER } from '../tokens';

export const CARD_TEXT = {
  lead: { m: 0, fontFamily: ROSTER.font, fontSize: 16, lineHeight: '24px', color: ROSTER.ink },
  small: { m: 0, fontFamily: ROSTER.font, fontSize: 14, lineHeight: '20px', color: ROSTER.muted },
  strong: { m: 0, fontFamily: ROSTER.font, fontSize: 16, lineHeight: '24px', fontWeight: 700, color: ROSTER.ink },
} as const;

export function ProfileCard({ title, wide = false, gap, children }: { title: string; wide?: boolean; gap?: string; children: ReactNode }) {
  return (
    <Box
      component="section"
      data-testid="profile-card"
      sx={{ bgcolor: ROSTER.cardBg, borderRadius: '16px', boxShadow: ROSTER.cardShadow, p: '24px', display: 'flex', flexDirection: 'column', gap: gap ?? (wide ? '16px' : '12px'), minWidth: 0 }}
    >
      <Typography component="h2" sx={{ m: 0, fontFamily: ROSTER.font, fontSize: 20, fontWeight: 700, lineHeight: '28px', color: ROSTER.ink }}>
        {title}
      </Typography>
      {children}
    </Box>
  );
}

export type ChipTone = 'neutral' | 'active' | 'good' | 'warn';

const CHIP_TONES: Record<ChipTone, { bg: string; fg: string }> = {
  neutral: { bg: '#EBEBEF', fg: ROSTER.ink },
  active: ROSTER.chip.active,
  good: ROSTER.chip.active,
  warn: WARNING_CHIP,
};

export function Chip({ children, tone = 'neutral', title }: { children: ReactNode; tone?: ChipTone; title?: string }) {
  const colors = CHIP_TONES[tone];
  return (
    <Box component="span" title={title} data-testid="profile-chip" sx={{ display: 'inline-flex', alignItems: 'center', p: '4px 12px', borderRadius: '9999px', bgcolor: colors.bg, color: colors.fg, fontFamily: ROSTER.font, fontSize: 12, fontWeight: 700, lineHeight: '16px', whiteSpace: 'nowrap' }}>
      {children}
    </Box>
  );
}
